/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import { useDispatch } from 'react-redux';
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';
import { setNDCSelectedNDCTab } from '../store/action';

const NDCTabs = ({ selectedTab, tabData }) => {
  const dispatch = useDispatch();
  return (
    <div
      className='mui-custom-form no-margin p-0 ndc-tab'
      style={{ width: 'max-content' }}
    >
      <RadioGroupComponent
        labelName={''}
        optionList={tabData}
        defaultValue={selectedTab}
        filterAction={(e) => dispatch(setNDCSelectedNDCTab(e))}
      />
    </div>
  );
};

export default NDCTabs;
